import { Injectable } from '@angular/core';
import mixpanel, { Dict } from 'mixpanel-browser';

@Injectable({ providedIn: 'root' })
export class MixpanelService {
  private initialized = false;

  init(config: { token: string; enabled: boolean; apiHost: string }): void {
    if (!config.enabled || !config.token) {
      return;
    }

    try {
      mixpanel.init(config.token, {
        autocapture: false,
        record_sessions_percent: 0,
        api_host: config.apiHost,
        property_blacklist: ['$current_url', '$referrer', '$initial_referrer'],
      });

      this.initialized = true;
    } catch (error) {
      console.error('[Mixpanel] Failed to initialize with host:', config.apiHost, error);
    }
  }

  register(properties: Dict): void {
    if (!this.initialized) return;
    mixpanel.register(properties);
  }

  track(eventName: string, properties: Dict): void {
    if (!this.initialized) return;
    mixpanel.track(eventName, properties);
  }

  reset(): void {
    if (!this.initialized) return;
    mixpanel.reset();
  }
}
